import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"undertake-transaction"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M19.7812 14.5553L13.5 16L13.1251 16C13.6223 16 14.0992 15.8024 14.4508 15.4508C14.8025 15.0992 15 14.6223 15 14.125C15 13.6277 14.8025 13.1508 14.4508 12.7992C14.0992 12.4476 13.6223 12.25 13.125 12.25H8.4375C8.14175 12.2493 7.84877 12.3069 7.5753 12.4195C7.30182 12.5321 7.05324 12.6975 6.84375 12.9063L4.5 15.25V20.5H11.25L17.25 19L20.8894 17.4475C21.148 17.3184 21.3656 17.1197 21.5176 16.8738C21.6697 16.6279 21.7501 16.3444 21.75 16.0553C21.7497 15.8159 21.6942 15.5797 21.5878 15.3652C21.4814 15.1507 21.327 14.9636 21.1365 14.8185C20.9461 14.6734 20.7247 14.5741 20.4897 14.5285C20.2546 14.4829 20.0122 14.492 19.7812 14.5553Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M4.5 15.25V20.5H1V15.25H4.5Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M18.5 2C20.433 2 22 3.567 22 5.5C22 7.433 20.433 9 18.5 9C17.7564 9 17.0669 8.76809 16.5 8.37266C16.5035 8.37021 16.507 8.36769 16.5104 8.36523C15.9416 8.76515 15.2482 9 14.5 9C12.567 9 11 7.433 11 5.5C11 3.567 12.567 2 14.5 2C15.2482 2 15.9416 2.23481 16.5104 2.63472C16.507 2.63227 16.5035 2.62978 16.5 2.62734C17.0669 2.23191 17.7564 2 18.5 2Z","fillRule":"evenodd","clipRule":"evenodd"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4.5 20.5H11.25L17.25 19L20.8894 17.4475C21.148 17.3184 21.3656 17.1197 21.5176 16.8738C21.6697 16.6279 21.7501 16.3444 21.75 16.0553C21.7497 15.8159 21.6942 15.5797 21.5878 15.3652C21.4814 15.1507 21.327 14.9636 21.1365 14.8185C20.9461 14.6734 20.7247 14.5741 20.4897 14.5285C20.2546 14.4829 20.0122 14.492 19.7813 14.5553L13.5 16L13.1251 16M4.5 20.5V15.25M4.5 20.5H1V15.25H4.5M4.5 15.25L6.84375 12.9063C7.05324 12.6975 7.30182 12.5321 7.5753 12.4195C7.84877 12.3069 8.14175 12.2493 8.4375 12.25L13.125 12.25C14.1605 12.25 15 13.0895 15 14.125C15 15.1605 14.1605 16 13.125 16H11","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M17 2.33682C17.4546 2.12085 17.9632 2 18.5 2C20.433 2 22 3.567 22 5.5C22 7.433 20.433 9 18.5 9C17.9632 9 17.4546 8.87915 17 8.66318M14.5 9C12.567 9 11 7.433 11 5.5C11 3.567 12.567 2 14.5 2C16.433 2 18 3.567 18 5.5C18 7.433 16.433 9 14.5 9Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const UndertakeTransaction = Vue.extend<IconProps>({
  name: 'UndertakeTransactionIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'undertake-transaction',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default UndertakeTransaction;
